import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import Swal from "sweetalert2";
// import '../libs/css/bootstrap.css';
// import '../libs/css/style.css';
// import '../libs/css/responsive.css';
import '../libs/css/custom-bootstrap-margin-padding.css';
import $ from "jquery";
// import Loaders from "./Dashboards/Loaders";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from '../utils/constants';


export default function Login(props){
    useEffect(() => {document.title = "Admin Login | Oatek VAS"}, []);

    const { objectToFormData } = props;
    const rememberLogin = localStorage.getItem('rememberLoginFs');
    const rememberMe = rememberLogin ? true : false;
    const userInput = localStorage.getItem('userVASInputs');
    const inputObject = JSON.parse(userInput);
    const isEmail = inputObject ? atob(inputObject.email) : '';
    const isPassword = inputObject ? atob(inputObject.password) : '';


    const { register, handleSubmit, formState: {errors, isSubmitting, isValid} } = useForm({
        mode: "onChange",
        defaultValues: {
            email: rememberMe ? isEmail : '',
            password: rememberMe ? isPassword : '',
            remember: rememberMe
        }
    });

    const [showLogin, setShowLogin] = useState(true);
    const [showReset, setShowReset] = useState(false);
    const [isChecked, setIsChecked] = useState(rememberMe);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();


    const userData = localStorage.getItem('userVASData');
    const userObj = JSON.parse(userData);
    const isAuthenticated = { 'isLoggedIn': userObj !== null ? userObj.isLoggedIn : false }

    if(isAuthenticated.isLoggedIn){
        navigate("/dashboard");
    }

    const forgotPassLink = () => {
        setShowLogin(!showLogin);
        setShowReset(!showReset);
    }

    const loginLink = () => {
        setShowLogin(!showLogin);
        setShowReset(!showReset);
    }

    const togglePassword = () => {
        setShowPassword(!showPassword);
    }


    const forgetPasswordAuth = async (data) => {
        console.log(data);
        navigate("/login");
        return;
        try {
            const response = await fetch(API_ROUTES.SIGN_IN, {
                method: "POST",
                body: objectToFormData(data),
            });
            const responseJSON = await response.json();
            const message = responseJSON.message;

            if(responseJSON.status.toString() === "200"){
                const responseDetails = responseJSON.data;

                const userData = {};
                userData.isLoggedIn = true;
                userData.responseDetails = responseDetails;

                if(responseDetails.twoFa_status === 1){ // is2FA
                    const response1 = await fetch(API_ROUTES.TWO_FA_TOKEN, {
                        method: 'POST',
                        body: objectToFormData(data),
                        headers: {'token': userData?.responseDetails?.token},
                    });
                    const responseJSON2 = await response1.json();
                    // console.log(responseJSON2);

                    const result = await Swal.fire({
                        title: '2 Factor Authentication! Enter the code sent to your email and continue',
                        html: `<div className="text-left swal_inputs swal_inputs_pass">
                                <input type="number" id="ccode" className="swal2-input" placeholder="Enter code">
                            </div>`,
                        confirmButtonText: 'Continue',
                        icon: 'question',
                        iconHtml: '?',
                        focusConfirm: false,
                        showCancelButton: true,
                        cancelButtonColor: '#999',
                        preConfirm: () => {
                            const ccode = Swal.getPopup().querySelector('#ccode').value
                            if (!ccode) {
                            Swal.showValidationMessage(`Please enter code sent to your email`);
                            return;
                            }
                            return { ccode: ccode }
                        }
                    })
                    if (result.isConfirmed) {
                        Swal.fire({
                            title: 'Processing...',
                            text: "Please wait a second for a response...",
                            icon: 'success',
                            showConfirmButton: false,
                            confirmButtonColor: '#027937',
                            cancelButtonColor: '#d33',
                        });
                        try {
                            const dataString = { 
                                twoFatoken: result.value.ccode,
                                email: userData?.responseDetails?.email,
                            };
                            const response = await fetch(API_ROUTES.TWO_FA_CHECK, {
                                method: 'POST',
                                body: objectToFormData(dataString),
                                headers: {'token': userData?.responseDetails?.token},
                            });
                            const responseJSON = await response.json();
                            if (responseJSON.status === 200) {
                                localStorage.setItem('userVASData', JSON.stringify(userData));
                                const userInput = {};
                                userInput.email = btoa(data.email);
                                userInput.password = btoa(data.password);

                                if(isChecked){
                                    localStorage.setItem('userVASInputs', JSON.stringify(userInput));
                                }else{
                                    localStorage.removeItem('userVASInputs');
                                }
                                localStorage.setItem('rememberLoginFs', data.remember);

                                Swal.fire({
                                    title: 'Successful',
                                    html: "",
                                    icon: 'success',
                                    timer: 1000,
                                });
                                navigate("/dashboard");
                                return;
                            } else {
                                Swal.fire({
                                    title: 'Error',
                                    html: responseJSON.message || 'An error occurred during the POST request.',
                                    icon: 'error',
                                });
                                return;
                            }
                        } catch (error) {
                            Swal.fire({
                                title: 'Error',
                                text: error.message || 'An error occurred during the POST request.',
                                icon: 'error',
                            });
                            return;
                        }
                    };
                    
                }else{
                    localStorage.setItem('userVASData', JSON.stringify(userData));
                    const userInput = {};
                    userInput.email = btoa(data.email);
                    userInput.password = btoa(data.password);

                    if(isChecked){
                        localStorage.setItem('userVASInputs', JSON.stringify(userInput))
                    }else{
                        localStorage.removeItem('userVASInputs');
                    }
                    localStorage.setItem('rememberLoginFs', data.remember);
                    navigate("/dashboard");
                }

                
            }else{
                Swal.fire({
                    title: "<font className='error_title'>Error</font>",
                    html: `${message}`,
                    icon: "error"
                });
            }
        } catch (error) {
            Swal.fire({
                icon:   "error",
                html:   error,
                title:  "Error",
            });
        }
    }

    return (
      <div className="fix-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6">
              <div className="card mb-0 h-auto">
                <div className="card-body">
                  <div className="text-center mb-0 mt--10">
                    <img
                      src="assets/images/oatek_logo.png"
                      style={{ width: "160px" }}
                      alt=""
                    />
                  </div>
                  <h4 className="text-center mb-4">Forgot Password</h4>
                  <form
                    className="theme-form"
                    onSubmit={handleSubmit(forgetPasswordAuth)}
                  >
                    <div className="form-group">
                      <label className="form-label" for="username">
                        Email Address
                      </label>
                      <input
                        type="text"
                        className="form-control form-control1"
                        placeholder="Enter email address"
                        id="username"
                      />
                    </div>
                    <div className="form-row d-flex flex-wrap justify-content-between mt--5 mb-5">
                      <div className="form-group"></div>
                      <div className="form-group ms-2">
                        <a className="btn-link" href="login">
                          Back To Login
                        </a>
                      </div>
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn1 btn-primary btn-block"
                      >
                        Forgot Password
                      </button>
                    </div>
                  </form>
                  <div className="new-account mt-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}